module.exports = __webpack_public_path__ + "static/img/281_TO8_2423_og.d456c5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/281_TO8_2423_og.jpg
// module id = jNYH
// module chunks = 0